module.exports = __webpack_public_path__ + "static/media/served-family-heart.b34fb4ae.svg";